import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';

export default function IssueDetail({ issues }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const issue = issues[parseInt(id, 10)];

  if (!issue) return <div>Issue not found.</div>;

  return (
    <div className="table-container full-width-table">
      <h2>Issue Detail</h2>
      <p><b>Date Reported:</b> {issue.dateReported}</p>
      <p><b>By Whom:</b> {issue.byWhom}</p>
      <p><b>Description:</b> {issue.description}</p>
      <p><b>Location:</b> {issue.location}</p>
      <p><b>Compliance Risk:</b> {issue.complianceRisk}</p>
      <p><b>Priority:</b> {issue.priority}</p>
      <p><b>Estimated Cost:</b> {issue.estimatedCost}</p>
      <p><b>Fund:</b> {issue.fund}</p>
      <p><b>Target Qtr:</b> {issue.targetQtr}</p>
      <p><b>Status:</b> {issue.status}</p>
      <button onClick={() => navigate(-1)}>Back</button>
      <button onClick={() => navigate(`/issues/edit/${id}`)}>Edit</button>
    </div>
  );
}
